import React, {useEffect, useState} from 'react'
import './styles/TableBienes.css'
import './styles/TableBienes2.css'
import {useDispatch, useSelector} from 'react-redux'
import {State} from '../../../../reducers'
import TablaDocsAsociados from './TablaDocsAsociados'
import ModalDocsAsociados from './ModalsDocsAsociados'
import { docsFormSetChange, docsSetDocsAsociados } from '../../../../actions/documentos/documentos.actions'
import ModalEliminar from './Modals/ModalEliminar'
import EditIcon from '../../../../media/felsv/down-arrow-svgrepo-com.svg'

export const docsAsociadosItems = [
  {valor: 'Emisor', codigo: '1'},
  {valor: 'Receptor', codigo: '2'},
] 

const OtrosDocAsociados = () => {
  const dispatch = useDispatch()
  const [showModalDocs, setShowModalDocs] = useState(false)
  const [showModalDelete, setShowModalDelete] = useState(false)
  const [showContent, setShowContent] = useState(false)
  const {formDoc, dataDocsAsociados} = useSelector((state: State) => state.documentos.otrosDocumentosAsociados)

  const openModalAdd = () => {
    setShowModalDocs(true);
    dispatch(docsFormSetChange({
      mode: 'add',
      id: 0,
      tipo: '',
      identificacion: '',
      descripcion: '',
    }));
  }

  const openModalEliminar = (doc: any) => {
    dispatch(docsFormSetChange({...doc}));
    setShowModalDelete(true);
  }

  const openModalEditar = (doc: any) => {
    dispatch(docsFormSetChange({...doc, mode: 'edit'}));
    setShowModalDocs(true);
  }

  const handleEliminarDoc = () => {
    dispatch(docsSetDocsAsociados(dataDocsAsociados.filter((doc: any) => doc.id !== formDoc.id)))
    setShowModalDelete(false);
  }

  return (
    <div id='w-node-_5c6af4dc-0d52-341f-2ef6-a52695e59ed4-0b1e6fa6' className='w-layout-cell'>
      <div style={{width: '100%', boxShadow: "none"}} className='card'>
        <h3 className='card-title l' onClick={() => setShowContent(!showContent)} style={{cursor: 'pointer'}}>
          Otros documentos asociados
          <img src={EditIcon} style={{marginLeft: '16px', width: '15px'}} />
        </h3>
        {
          showContent && 
          (
            <div style={{overflowX: "scroll"}}>
              <div className='w-layout-hflex button-actions' style={{margin: '16px 0px'}}>
                <button className='m button w-inline-block' style={{maxWidth: '200px'}} onClick={openModalAdd}>Agregar documento</button>
              </div>
              <div className='form-separator'></div>
              <TablaDocsAsociados openModalEliminar={openModalEliminar} openModalEditar={openModalEditar} sinAcciones={false} />
              {
                showModalDocs && <ModalDocsAsociados onCancel={() => setShowModalDocs(false)} />
              }
              {
                showModalDelete && <ModalEliminar eliminar={true} actionEliminar={handleEliminarDoc} closeModalEliminar={() => setShowModalDelete(false)} />
              }
            </div>
          )
        }
      </div>
    </div>
  )
}

export default OtrosDocAsociados
